import {Vue, Component, Watch} from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import Loading from '@/components/loading/loading';
import moment from 'moment';

@Component({
  components: {
    Loading
  },
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm) => {
      if (
        !vm.getIsToken ||
        !vm.getSubscription ||
        !vm.isBeforeDeadline ||
        vm.isCurrentOrderActive ||
        !vm.isSubscriptionActive ||
        (Array.isArray(vm.getSubscription.details) && !vm.getSubscription.details)
      ) {
        next("/mi-menu/inicio");
      } else {
        next();
      }
    });
  }
})
export default class SubscriptionsOpenWeek extends Vue {

  // Actions
  @Action action_getMenus;
  @Action action_getMenuOptions;
  @Action action_getMenuItems;
  @Action action_updateSubscription;
  @Action action_getCurrentOrder;
  @Action action_getAllSubscriptions;

  // Getters
  @Getter getSubscription;
  @Getter getSubscriptionTemporal;
  @Getter getIsToken;
  @Getter getMenus;
  @Getter getCity;
  @Getter getCurrentOrder;
  @Getter getCurrentMenu;

  // Mutations
  @Mutation CURRENT_MENU;
  @Mutation CURRENT_MENU_OPTION;
  @Mutation SUBSCRIPTION_TEMPORAL;
  @Mutation CURRENT_SUBSCRIPTION_MENU;
  @Mutation CURRENT_DAY;

  subscriptionMenus = [];
  isLoading = false;
  detailsSubscriptionMenus = [];

  get isSubscriptionActive() {
    let response = false;
    if (this.getSubscription && this.getSubscription.status) {
      response =
        this.getSubscription.status === "active" || this.getSubscription.status === "pending";
    }
    return response;
  }

  get getPersonQuantityMessage() {
    let response = "";
    if (
      this.getSubscription &&
      this.getSubscription.person_quantity &&
      this.getSubscription.count_week >= 0
    ) {
      response = `Semana #${this.getSubscription.count_week + 1} configurada para ${
        this.getSubscription.person_quantity
      } ${this.getSubscription.person_quantity === 1 ? "persona" : "personas"}`;
    }
    return response;
  }

  get availableSubscriptionMenus() {
    return this.subscriptionMenus.filter((subscriptionMenu) => subscriptionMenu.count);
  }

  get getWeekLabel() {
    let response = "";
    if(this.getSubscription.deal_date) {
      const dealDate = moment(this.getSubscription.deal_date);
      const endOfWeek = dealDate.clone();
      endOfWeek.add(1, 'week');
      response = `${dealDate.format("ddd DD-MMM")} al ${endOfWeek.format("ddd DD-MMM")}`;
    }
    return response;
  }

  get isCurrentOrderActive() {
    let response = false;
    if (this.getCurrentOrder && !this.getIsTerminalStatus && !this.getIsFinished) {
      response = true;
    }
    return response;
  }

  get getIsTerminalStatus() {
    let response = false;
    if (this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      response =
        status === "troubleshooting_restaurant" ||
        status === "order_not_generated" ||
        status === "order_canceled_by_restaurant" ||
        status === "order_canceled_in_handoff" ||
        status === "troubleshooting_hand_off";
    }
    return response;
  }

  get getIsFinished() {
    let response = false;
    if(this.getCurrentOrder && this.getCurrentOrder.status) {
      const status = this.getCurrentOrder.status;
      response = status === "order_completed";
    }
    return response;
  }

  get getDeliveryDay() {
    let response = "";
    if(this.getSubscription.deal_date) {
      response = moment(this.getSubscription.deal_date).format("ddd DD-MMM");
    }
    return response;
  }

  get getProgramSchedule() {
    let response = "";
    if(this.getSubscription && this.getSubscription.program_schedule) {
      response = this.getSubscription.program_schedule;
    }
    return response;
  }

  get getRestartDay() {
    let response = "";
    if(this.getSubscription.deal_date) {
      const dealDate = moment(this.getSubscription.deal_date);
      response = dealDate
        .clone()
        .add(1, "day")
        .startOf("day")
        .format("ddd DD-MMM");
    }
    return response;
  }

  get getDeadline() {
    let response = "";
    if(this.getSubscription.deadline_update_date) {
      const deadLineDate = moment(this.getSubscription.deadline_update_date);
      response = deadLineDate.format("ddd DD-MMM hh:mm a");
    }
    return response;
  }

  get isBeforeDeadline() {
    let response = true;
    if(this.getSubscription && this.getSubscription.deadline_update_date) {
      const today = moment(new Date());
      const deadline = moment(this.getSubscription.deadline_update_date);
      response = today.isBefore(deadline);
    }
    return response;
  }

  async mounted() {
    this.isLoading = true;
    this.subscriptionMenus = [];
    this.CURRENT_MENU(null);
    this.CURRENT_MENU_OPTION(null);
    this.CURRENT_DAY(null);
    if(!this.isBeforeDeadline) {
      this.$swal({
        title: "Orden activa",
        text: `Podrás configurar tu siguiente semana luego de recibir tu pedido.`
      });
      this.$router.replace({ name: "subscriptions_settingsNew" });
    } else {
      try {
        await this.action_getAllSubscriptions({ commerceId: this.getCity.id });
        if (this.getSubscription && this.getSubscription.last_order) {
          await this.action_getCurrentOrder(this.getSubscription.last_order);
        }
        this.detailsSubscriptionMenus = this.getSubscription.details_subscription_menus.filter(
          (menu) => menu.day.length
        );
      } catch (error) {
        this._showErrorMessage(error);
      }
      if(!this.getSubscription.checked_by_user) {
        await this.setCheckedByUser();
      }
      this.isLoading = false;
    }
  }

  async setCheckedByUser() {
    this.isLoading = true;
    try {
      const payload = {
        commerceId: this.getCity.id,
        subscriptionId: this.getSubscription.id,
        subscription: {
          subscription: {
            checked_by_user: true
          }
        }
      };
      await this.action_updateSubscription(payload);
    } catch(error) {
      this._showErrorMessage(error);
    }
    this.isLoading = false;
  }

  _onChangeMenuDetail(menuId, menuOptionId, day) {
    const menu = this.findMenuById(menuId);
    this.CURRENT_MENU(menu);
    if(menu) {
      const menuOption = this.findMenuOptionById(menuOptionId);
      this.CURRENT_MENU_OPTION(menuOption);
      if(menuOption && day) {
        this.CURRENT_DAY(day);
        this.$router.push({
          name: "openWeek_menuConfiguration",
          params: {
            menu_id: menu.id,
            count_id: day.count_id
          }
        });
      }
    }
  }

  _routeBack() {
    this.$router.replace({ name: 'subscriptions_settingsNew' });
  }

  sortDays(a, b) {
    return a.count_id - b.count_id;
  }

  private _showErrorMessage(error) {
    let msg = "";
    if(error && error.response && error.response.data && error.response.data.message) {
      msg = error.response.data.message;
    }
    this.$swal({
      title: "Error",
      text: "¡Ups! Hubo un error procesando la solicitud. " + msg
    });
  }

  private findMenuById(menuId) {
    return this.getMenus.find((menu) => menu.id === menuId);
  }

  private findMenuOptionById(menuOptionId) {
    return this.getCurrentMenu.menu_options.find((menuOption) => menuOption.id === menuOptionId);
  }
}
